export const files = ['Composition & compatibility', 'Instructions for use'];
